import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHits, useSearchBox } from "react-instantsearch-hooks";
import ReactTooltip from "react-tooltip";
import { useTracks } from "../../hooks/useTracks";
import { hitToUiTrack, SearchBox, TrackSearchContext } from "../../hooks/useTrackSearch";
import { useScreenSize } from "../../styles/media-queries";
import Button from "../inputs/Button";
import Loader from "../misc/Loader";
import { Paragraph, Subtitle } from "../misc/Typography";
import { TrackRowSelectable } from "../track/TrackRowCompact";
import { TrackUploadArea } from "./TrackUploadArea";

function _TrackUpload({ initSelected = [], onDoneSelecting, ...rest }) {
  const { phone } = useScreenSize();
  const {
    uploadFiles,
    tracks,
    loadMore,
    hasMore,
    fileUploadsArr,
    selectTrack,
    deselectTrack,
    trackSelected,
    selectedTracks,
    deleteTrack,
  } = useTracks(5, initSelected, true);

  // todo: extract list track into component and add date grouping + have max width instead of width

  const { query, refine, isSearchStalled } = useSearchBox();
  const { hits } = useHits();
  const showHits = query?.length > 0;
  const uiTrackToTrackRow = (uiTrack, idx) => (
    <div key={`existing-track ${uiTrack.track.id}#${idx}`} className="relative">
      {/* {trackSelected(track) && <IoMdCheckmark className='z-10 absolute top-1/2 left-1 -translate-y-1/2 mr-4' />} */}

      <TrackRowSelectable
        className="pl-5"
        selectable
        onSelect={() => selectTrack(uiTrack)}
        onDeselect={() => deselectTrack(uiTrack)}
        selected={trackSelected(uiTrack)}
        {
          ...{} /* @ts-ignore */
        }
        uiTrack={uiTrack}
        onDelete={() => deleteTrack(uiTrack)}
        uploadProgress={uiTrack?.progress}
      />
    </div>
  );

  return (
    <div>
      <div className="mb-4">
        <Subtitle className="-mb-1">Select tracks for this pack</Subtitle>
        <Paragraph className={`px-2 text-center text-sm`}>
          These are all your tracks. Select some, or upload new ones to be in this pack.
        </Paragraph>
      </div>
      {/* <ClickAwayable onboardingKey={'track-upload'}>Upload tracks</ClickAwayable> */}
      <TrackUploadArea uploadFiles={uploadFiles} />

      <SearchBox placeholder={"Search tracks"} />
      <div style={{ height: 150 }} className="relative transition-all overflow-auto">
        {showHits ? (
          hits.map(hitToUiTrack).map(uiTrackToTrackRow)
        ) : (
          <InfiniteScroll
            dataLength={tracks.length} //This is important field to render the next data
            next={loadMore}
            hasMore={hasMore}
            height={150}
            loader={<Loader />}
          >
            {/* existing */}
            {tracks.map(uiTrackToTrackRow)}
          </InfiniteScroll>
        )}
      </div>

      <div className={"flex justify-end"}>
        <div data-tip={!selectedTracks?.length ? "Select some tracks for your new pack" : undefined}>
          <Button
            onClick={() =>
              onDoneSelecting(
                selectedTracks.map(
                  (selTrack) =>
                    tracks.find((alTrack) => selTrack.track.path === alTrack.track.path) ||
                    fileUploadsArr.find((fUpTrack) => selTrack.track.path === fUpTrack.track.path) ||
                    selTrack
                )
              )
            }
            primary
            disabled={!selectedTracks?.length}
            className={"mt-4 w-24 text-center"}
          >
            Done
          </Button>

          <ReactTooltip delayShow={600} place="bottom" effect="solid" />
        </div>
      </div>
    </div>
  );
}

export default function TrackUpload({ ...rest }) {
  return (
    <TrackSearchContext>
      <_TrackUpload {...rest} />
    </TrackSearchContext>
  );
}
